export default {
  "b2b.zadost-editace-widget.title": "Request {id}",
  "b2b.zadost-editace-widget.form.field.zakaznik": "Customer",
  "b2b.zadost-editace-widget.form.field.uzivatel": "User",
  "b2b.zadost-editace-widget.form.field.projekt": "Project",
  "b2b.zadost-editace-widget.form.field.fixni": "Fixed",
  "b2b.zadost-editace-widget.form.field.produkt": "Product",
  "b2b.zadost-editace-widget.form.field.zdroj": "Resource",
  "b2b.zadost-editace-widget.form.field.termin": "Rezervation time",
  "b2b.zadost-editace-widget.form.field.doplnkove-sluzby":
    "Additional services",
  "b2b.zadost-editace-widget.form.field.poznamka-zakaznika": "Customer's note",
  "b2b.zadost-editace-widget.form.field.poznamka-strojvedouci": "Driver's note",
  "b2b.zadost-editace-widget.form.field.poznamka-spravce":
    "Administrator's note",
  "b2b.zadost-editace-widget.form.field.historie": "History",
  "b2b.zadost-editace-widget.form.button.submit": "Save notes",
  "b2b.zadost-editace-widget.save-dialog.title": "Saving request notes",
  "b2b.zadost-editace-widget.title-description.label": "Created"
};
